import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';

export const themeOptions: ThemeOptions = {
	typography: {
		fontFamily: 'Jost-Medium, sans-serif',
	},
	palette: {
		primary: {
			main: '#16d7db',
		},
		secondary: {
			main: '#916DED',
		},
		error: {
			main: '#CC0610',
		},
		warning: {
			main: '#CC0610',
		},
		info: {
			main: '#916DED',
		},
		success: {
			main: '#16d7db',
		},
	},
	overrides: {
		MuiButton: {
			root: {
				height: 40,
				borderRadius: 21,
				textTransform: 'none',
				fontWeight: 'bold',
				fontSize: 18,
				lineHeight: '24px',
			},
			sizeLarge: {
				height: 48,
				textTransform: 'none',
				borderRadius: 25,
				fontWeight: 'bold',
				fontSize: 20,
				lineHeight: '32px',
			},
			sizeSmall: {
				height: 32,
				textTransform: 'none',
				borderRadius: 21,
				fontWeight: 'bold',
				fontSize: 14,
				lineHeight: '15px',
			},
		},
		MuiTextField: {
			root: {
				'& .MuiOutlinedInput-root': {
					borderRadius: 8,
				},
			},
		},
		MuiDialog: {
			root: {
				'& .MuiPaper-rounded': {
					borderRadius: 8,
				},
			},
		},
		MuiDialogTitle: {
			root: {
				textAlign: 'center',
			},
		},
		MuiDialogActions: {
			root: {
				justifyContent: 'center',
				marginTop: 32,
			},
		},
	},
};
